import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Github from "./Github";
import Techstack from "./Techstack";
import Aboutcard from "./AboutCard";
// import laptopImg from "../../Assets/about.png";
import laptopImg from "../../Assets/work_dp.jpeg";
import Toolstack from "./Toolstack";
import Type from "./Type";
import Type2 from "./Type2";
import homeLogo from "../../Assets/untamed.gif";

function About() {
  return (
    <section>
      <Container fluid className="home-section" id="home">
        <Particle />
        <Container className="home-content">
          <Row>
            <Col md={7} className="home-header">
              <h1 style={{ paddingBottom: 15 }} className="heading">
                Hola <Type2/> <span className="wave" role="img" aria-labelledby="wave">
                  👋🏻 
                </span>
                
              </h1>
              {/* <h3 color="yellow">What inspired us?</h3> */}

              <h4 style={{ paddingBottom: 15, color: 'yellow',paddingLeft: 50 }} > Did you know? </h4>
              <h4 style={{paddingBottom: 15, paddingLeft: 50 }}>We spend a lot of our 20s in unlearning what we learned before. But, why? Isn't that a red flag on how we learn?</h4>
              <br/>
              <h4 style={{paddingBottom: 15, paddingLeft: 50 }}><i>
              We’re like snow globes, We spend all of our time, energy, words,
              and money creating a flurry, trying not to know, making sure that the
              snow doesn’t settle so we never have to face the fiery truth inside us,
              solid and unmoving. We keep ourselves shaken up because there are dragons in our center.<br/></i>
              </h4>

            </Col>
            <Col md={5} style={{ paddingBottom: 20 }}>
              <img
                src={homeLogo}
                alt="home pic"
                className="img-fluid"
                style={{ maxHeight: "1000px", maxWidth: "1000px" }}
              />
            </Col>

            
          </Row>
                  </Container>
      </Container>
      {/* <Home2 /> */}
    </section>
  );
}

export default About;
